import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Service } from "../../../../../models/service";
import { ServiceCopyControllerService } from "../../../../../services/service-controller/service-copy-controller.service";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../pages/base-error";
import { ServiceCopyModalComponent } from "../../../..//pages/service-detail/service-copy-modal.component";

@Component({
  selector: "service-settings-export",
  templateUrl: "./service-settings-export.component.html",
})
export class ServiceSettingsExportComponent extends BaseError implements OnInit {
  public serviceId: string;
  @Input() public service: Service;
  public showCopyServiceModal: any = { value: false };
  public blob: any;
  public snapshotList: any[] = [];

  public page: number = 0;
  public maxPage: number;
  public loading: boolean = false;


  @ViewChild(ServiceCopyModalComponent) public serviceCopyModal: ServiceCopyModalComponent;

  constructor(
    private serviceCopyControllerService: ServiceCopyControllerService,
    private serviceControllerService: ServiceControllerService,
    private route: ActivatedRoute,
    toastr: ToastrService,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    if (!this.service?.id || !this.service) {
      this.route.parent.params.subscribe((params) => {
        this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
        if (this.serviceId != null) {
          this.loadService();
        } else {
          this.service = new Service();
        }
      });
    } else {
      this.serviceId = this.service.id;
    }
  }

  public initCopy() {
    this.serviceCopyModal.copy();
  }

  public copyService() {
    this.showCopyServiceModal.value = true;
  }

  public closeExport() {
    this.showCopyServiceModal.value = false;
  }

  public downloadSnapshotFile(snapshotId: string) {
    this.serviceControllerService.getSnapshotFile(this.serviceId, snapshotId).subscribe(
          (data) => {
            this.blob = new Blob([data], { type: "application/octet-stream" });
            const downloadURL = window.URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = downloadURL;
            link.download = "service_" + this.service.name + ".json";
            link.click();
          },
          (error) => this.showErrorMessage(error),
        );
    }


  public downloadServiceJson(event: any) {
    if (event.save && event.properties) {
      const serviceCopyProperties = event.properties;
      this.serviceCopyControllerService.exportServiceWithProperties(this.serviceId, serviceCopyProperties).subscribe(
        (data) => {
          this.blob = new Blob([data], { type: "application/octet-stream" });
          const downloadURL = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = downloadURL;
          link.download = "service_" + event.properties.newServiceName + ".json";
          link.click();
        },
        (error) => this.showErrorMessage(error),
      );
      this.showCopyServiceModal.value = false;
    }
    if (event.delete || event.cancel) {
      this.showCopyServiceModal.value = false;
    }
  }

  public importOnTop(event: any) {
    if (event.status < 400 || event.save || event === "Service imported!") {
      this.responseSuccessful("Service imported successfully!");
    } else {
      this.showErrorMessage(event);
    }
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        this.service = data;
        this.loadSnapshots();
      },
    );
  }

  public loadSnapshots() {
    this.serviceControllerService.getSnapshotPage(this.serviceId, this.page).subscribe(
      (data) => this.responseUpdate(data),
      (error) => this.showErrorMessage(error),
    );
  }

  public getPage(index): void {
    if (!this.loading) {
      this.loading = true;
      this.page = index;
      this.serviceControllerService.getSnapshotPage(this.serviceId, this.page).subscribe(
        (data) => this.responseUpdate(data),
        (error) => this.showErrorMessage(error),
        () => this.loading = false,
      );
    }
  }

  public getPages(): any[] {
    const min = this.page - 2 > 0 ? this.page - 2 : 0;
    const max = this.page + 2 <= this.maxPage ? this.page + 2 : (this.page + 1 <= this.maxPage ? this.page + 1 : this.page);
    const pages = [];
    for (let i = min; i <= max; i++) {
      pages.push(i);
    }
    return pages;
  }

  public responseUpdate(data) {
    this.maxPage = data.totalPages - 1;
    this.snapshotList = data.snapshotList;
  }

  public showFeedback(publish: any) {
    if (publish.feedback === undefined) { return; }
    if (publish.showReason === undefined) {
      publish.showReason = true;
      return;
    }
    publish.showReason = !publish.showReason;
  }

  public formatPublisher(publisher) {
    if (publisher !== undefined && publisher !== null) {
      if (publisher.indexOf("(") !== -1) {
        return publisher.slice(0, publisher.indexOf("(") - 1);
      } else {
        return publisher;
      }
    }
  }

  public convertMillisecToMinSec(duration: any) {
    if (duration) {
      let seconds: any = Math.floor((duration / 1000) % 60);
      let minutes: any = Math.floor((duration / (1000 * 60)) % 60);
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;
      return minutes + ":" + seconds;
    } else {
      return null;
    }
  }
}
